import axios from 'axios'
import { baseUrl } from '~/env'

// Replaces @nuxtjs/axios, which pins axios to 0.21.x (CVE-2025-27152 & co,
// Asana 1217404830102197). Injects a plain axios@1.x instance as $axios with
// the $-prefixed helpers ($get/$post/...) the module used to provide, so the
// existing call sites and the token interceptor in plugins/axios.js work as-is.
// Must stay registered BEFORE @/plugins/axios in nuxt.config.js.
export default (ctx, inject) => {
  const instance = axios.create({ baseURL: baseUrl })

  for (const method of ['request', 'get', 'delete', 'head', 'options', 'post', 'put', 'patch']) {
    instance['$' + method] = (...args) => instance[method](...args).then((res) => res && res.data)
  }

  // ExcelUtils' exportToSalesforce reaches for window.$axios (file shared with
  // the vendict app, which sets it there); nothing in trustpage ever assigned
  // it, so that path would throw — expose the same instance to close the gap.
  if (process.client) window.$axios = instance

  inject('axios', instance)
}
